import React from "react";
import classes from "./PaddingContainer.module.css";
import clsx from "clsx";
import PageHeading from "../PageHeading";
const PaddingContainer = ({ children, className, heading ,...rest}) => {
  return (
    <div className={clsx(classes["mainWrapper"], className)} {...rest}>
      {heading && <PageHeading label={heading} />}
      {children}
    </div>
  );
};

export default PaddingContainer;
